'use client';

import { c as _c } from "react/compiler-runtime";
import { BorderBeam } from 'border-beam';
import { useTranslations } from 'next-intl';
import { type ReactNode, useId } from 'react';
import { AnimatedCountBadge } from '@/components/ui/animated-count-badge';
import { ChampionIconSolid, ChartRoseIconSolid, GiftIconSolid, Rocket01IconSolid } from '@/components/ui/icon/glyphs';
import { SegmentedControl } from '@/components/ui/segmented-control';
export type PositionCategory = 'markets' | 'winners' | 'proposals' | 'rewards';
export function PortfolioPositionsControls(t0) {
  const $ = _c(79);
  const {
    tab,
    category,
    count,
    rewardsCount,
    showRewardsCount,
    countHasMore: t1,
    rewardsHasMore: t2,
    onTabChange,
    onCategoryChange,
    onCategoryHover,
    onTabHover
  } = t0;
  const countHasMore = t1 === undefined ? false : t1;
  const rewardsHasMore = t2 === undefined ? false : t2;
  const t = useTranslations("profile.stats");
  const tNav = useTranslations("nav");
  const tRewards = useTranslations("profile.rewards");
  const id = useId();
  let t3;
  if ($[0] !== onCategoryChange) {
    t3 = function selectCategory(value) {
      if (value === "markets" || value === "winners" || value === "proposals" || value === "rewards") {
        onCategoryChange(value);
      }
    };
    $[0] = onCategoryChange;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const selectCategory = t3;
  let t4;
  if ($[2] !== t) {
    t4 = t("portfolio_section_title");
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <h2 className="text-body-lg font-medium text-foreground-secondary">{t4}</h2>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== count || $[7] !== countHasMore) {
    t6 = count === undefined ? null : <AnimatedCountBadge value={count} hasMore={countHasMore} data-testid="positions-count" />;
    $[6] = count;
    $[7] = countHasMore;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className="flex min-w-0 items-center gap-2">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = category === "rewards" ? "claimable" : "open";
  let t9;
  if ($[12] !== category || $[13] !== t || $[14] !== tRewards) {
    t9 = category === "rewards" ? tRewards("claimable") : t("open_tab");
    $[12] = category;
    $[13] = t;
    $[14] = tRewards;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = {
      key: t8,
      label: t9
    };
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = category === "rewards" ? "claimed" : "closed";
  let t12;
  if ($[19] !== category || $[20] !== t || $[21] !== tRewards) {
    t12 = category === "rewards" ? tRewards("claimed") : t("closed_tab");
    $[19] = category;
    $[20] = t;
    $[21] = tRewards;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t12) {
    t13 = {
      key: t11,
      label: t12
    };
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t10 || $[27] !== t13) {
    t14 = [t10, t13];
    $[26] = t10;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const t15 = `${id}-status`;
  let t16;
  if ($[29] !== t) {
    t16 = t("portfolio_section_title");
    $[29] = t;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== onTabChange || $[32] !== onTabHover || $[33] !== t14 || $[34] !== t15 || $[35] !== t16 || $[36] !== tab) {
    t17 = <SegmentedControl items={t14} active={tab} onChange={onTabChange} onItemPointerEnter={onTabHover} layoutId={t15} variant="chart-filled" asTabs={true} ariaLabel={t16} />;
    $[31] = onTabChange;
    $[32] = onTabHover;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
    $[36] = tab;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t17 || $[39] !== t7) {
    t18 = <div className="flex items-center justify-between gap-2">{t7}{t17}</div>;
    $[38] = t17;
    $[39] = t7;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== tNav) {
    t19 = tNav("markets");
    $[41] = tNav;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t19) {
    t20 = {
      key: "markets",
      label: t19,
      icon: ChartRoseIconSolid
    };
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== tNav) {
    t21 = tNav("winners");
    $[45] = tNav;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t21) {
    t22 = {
      key: "winners",
      label: t21,
      icon: ChampionIconSolid
    };
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== tNav) {
    t23 = tNav("launchpad");
    $[49] = tNav;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t23) {
    t24 = {
      key: "proposals",
      label: t23,
      icon: Rocket01IconSolid
    };
    $[51] = t23;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== tRewards) {
    t25 = tRewards("title");
    $[53] = tRewards;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== rewardsCount || $[56] !== rewardsHasMore || $[57] !== showRewardsCount) {
    t26 = showRewardsCount && rewardsCount !== undefined && rewardsCount > 0 ? <BorderBeam colorVariant="colorful" theme="auto" className="[--beam-inner-opacity:0]"><AnimatedCountBadge value={rewardsCount} hasMore={rewardsHasMore} animateOnMount={false} data-testid="rewards-count" /></BorderBeam> : null;
    $[55] = rewardsCount;
    $[56] = rewardsHasMore;
    $[57] = showRewardsCount;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  let t27;
  if ($[59] !== t25 || $[60] !== t26) {
    t27 = {
      key: "rewards",
      icon: GiftIconSolid,
      label: <span className="inline-flex items-center gap-1.5">{t25}{t26}</span>
    };
    $[59] = t25;
    $[60] = t26;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== t20 || $[63] !== t22 || $[64] !== t24 || $[65] !== t27) {
    t28 = [t20, t22, t24, t27];
    $[62] = t20;
    $[63] = t22;
    $[64] = t24;
    $[65] = t27;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  const t29 = `${id}-category`;
  let t30;
  if ($[67] !== t) {
    t30 = t("portfolio_section_title");
    $[67] = t;
    $[68] = t30;
  } else {
    t30 = $[68];
  }
  let t31;
  if ($[69] !== category || $[70] !== onCategoryHover || $[71] !== selectCategory || $[72] !== t28 || $[73] !== t29 || $[74] !== t30) {
    t31 = <div className="-mx-4 min-w-0 overflow-x-auto px-4 scrollbar-none"><SegmentedControl items={t28} active={category} onChange={selectCategory} onItemPointerEnter={onCategoryHover} layoutId={t29} variant="tab" indicatorClassName="bg-background-tertiary dark:bg-background-tertiary" asTabs={true} ariaLabel={t30} /></div>;
    $[69] = category;
    $[70] = onCategoryHover;
    $[71] = selectCategory;
    $[72] = t28;
    $[73] = t29;
    $[74] = t30;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  let t32;
  if ($[76] !== t18 || $[77] !== t31) {
    t32 = <>{t18}{t31}</>;
    $[76] = t18;
    $[77] = t31;
    $[78] = t32;
  } else {
    t32 = $[78];
  }
  return t32;
}